import { Table as AntTable, TableColumnType } from 'antd';

const { Column: AntColumn } = AntTable;

export const Column = <T extends object>({ ...props }: TableColumnType<T>) => {
  return <AntColumn<T> {...props} />;
};
